<template>
    <section class="sessao-landing-page" id="servicos">
        <h2 class="titulo-padrao" data-aos="fade" data-aos-duration="1200">Serviços</h2>
        
        <section class="conteudo-sessao-landing-page">
            <div class="card-servico" v-for="(servico, index) in servicos" :key="index" @click="$emit('abrir-servico', servico)" data-aos="fade" :data-aos-delay="index * 200" data-aos-duration="1200">
                <div class="fotos-servico">
                    <img
                        :src="servico.foto[fotoAtual[index] || 0]"
                        class="foto-servico"
                        :key="fotoAtual[index] || 0"
                    >
    
                    <div class="indicadores-fotos">
                        <button
                            v-for="(foto, fotoIndex) in servico.foto"
                            :key="fotoIndex"
                            :class="{ ativo: (fotoAtual[index] || 0) === fotoIndex }"
                            @click="fotoAtual[index] = fotoIndex"
                        ></button>
                    </div>
                </div>


                <div class="textos-servicos">
                    <h3 class="titulo-servico">{{ servico?.titulo }}</h3>
                    <p class="descricao-servico">{{ servico?.descricao }}</p>
                    <div class="dados-ui-fundo">
                        <p class="dados-ui">
                            <span
                                v-for="estrela in 5"
                                :key="estrela"
                                class="estrela"
                                :style="{
                                    '--preenchimento': `${Math.min(Math.max(servico.avaliacao - (estrela - 1), 0), 1) * 100}%`
                                }"
                            >
                                ★
                            </span>
                            <span class="nota">{{ servico.avaliacao }}</span>
                        </p>

                        <p class="dados-ui-texto">+ {{ servico?.total_feito }}</p>
                    </div>
                </div>

                <button class="contratar-servico" @click.stop="abrirWhatsApp(servico)">
                    <img src="@/assets/whatsapp-icon.svg" alt="wp" class="icon-botao-wp">
                    Fazer orçamento
                </button>
            </div>
        </section>
    </section>
</template>

<script>
import foto from "@/assets/banner.jpg";
import foto2 from "@/assets/ex.jpg";

export default{
    name: 'ServicosLandingPage',

    data(){
        return{
            fotoAtual: [],

            servicos:[
                {
                    titulo: "Higienização de Sofás",
                    descricao: "Limpeza completa do estofado para eliminar ácaros, vírus, fungos e bactérias, utilizando produtos e equipamentos específicos.",
                    foto: [foto, foto2, foto],
                    total_feito: 342,
                    avaliacao: 4.9,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Higieniza%C3%A7%C3%A3o%20de%20Sof%C3%A1s&type=phone_number&app_absent=0",
                    target: "_blank"
                },
                {
                    titulo: "Higienização de Colchões",
                    descricao: "Remoção de sujeiras e manchas amarelas, eliminando ácaros e fungos que fazem mal à saúde.",
                    foto: [foto2, foto, foto2],
                    total_feito: 215,
                    avaliacao: 4.7,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Higieniza%C3%A7%C3%A3o%20de%20Colch%C3%B5es&type=phone_number&app_absent=0",
                    target: "_blank"
                },
                {
                    titulo: "Limpeza e Higienização de Poltronas e Cadeiras",
                    descricao: "Limpeza focada na eliminação de ácaros e fungos para garantir a saúde no uso das peças.",
                    foto: [foto2, foto, foto2],
                    total_feito: 189,
                    avaliacao: 4.8,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Limpeza%20e%20Higieniza%C3%A7%C3%A3o%20de%20Poltronas%20e%20Cadeiras&type=phone_number&app_absent=0",
                    target: "_blank"
                },
                {
                    titulo: "Limpeza e Higienização de Tapetes e Carpetes",
                    descricao: "Conservação e higienização para manter as características originais do material.",
                    foto: [foto, foto2, foto],
                    total_feito: 156,
                    avaliacao: 4.6,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Limpeza%20e%20Higieniza%C3%A7%C3%A3o%20de%20Tapetes%20e%20Carpetes&type=phone_number&app_absent=0",
                    target: "_blank"
                },
                {
                    titulo: "Impermeabilização de Estofados e Tecidos",
                    descricao: "Aplicação de produto que protege as fibras, criando uma capa que mantém líquidos na superfície e evita manchas.",
                    foto: [foto2, foto, foto2],
                    total_feito: 278,
                    avaliacao: 5.0,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Impermeabiliza%C3%A7%C3%A3o%20de%20Estofados%20e%20Tecidos&type=phone_number&app_absent=0",
                    target: "_blank"
                },
                {
                    titulo: "Limpeza e Higienização de Bancos Automotivos",
                    descricao: "Limpeza profunda de bancos de tecido ou couro, avivando a cor de estofamentos, carpetes, teto, laterais e porta-malas.",
                    foto: [foto, foto2, foto],
                    total_feito: 412,
                    avaliacao: 4.9,
                    link_whatsapp: "https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C%20vim%20do%20cat%C3%A1logo%20e%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20o%20servi%C3%A7o%20de%20Limpeza%20e%20Higieniza%C3%A7%C3%A3o%20de%20Bancos%20Automotivos&type=phone_number&app_absent=0",
                    target: "_blank"
                }
            ]
        }
    },

    methods: {
        abrirWhatsApp(servico) {
            window.open(
                servico.link_whatsapp,
                '_blank'
            )
        }
    },

    mounted() {
        this.servicos.forEach((servico, index) => {
            this.fotoAtual[index] = 0;

            setInterval(() => {
                this.fotoAtual[index] =
                    (this.fotoAtual[index] + 1) % servico.foto.length;
            }, 4000);
        });
    }
}
</script>

<style scoped>
.sessao-landing-page{
    min-height: 100vh;
    width: 100%;
    padding: 42px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    border-bottom: solid 1px #12121232;
    border-radius: 10px;
}

.conteudo-sessao-landing-page{
    height: auto;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
}

.titulo-padrao{
    font-size: 32px;
}

.card-servico{
    width: 100%;
    height: 450px;
    overflow-y: hidden;
    box-sizing: border-box;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    cursor: pointer;
    transition: all ease 0.5s;
}

.card-servico:hover{
    background-color: #f2f2f2;
    border-radius: 10px;
}

.fotos-servico {
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;
    display: block;
    border-radius: 5px;
}

.foto-servico{
    width: 100%;
    height: 220px;
    object-fit: cover;
}

.indicadores-fotos {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    gap: 6px;
}

.indicadores-fotos button {
    width: 7px;
    height: 7px;
    padding: 0;

    border: none;
    border-radius: 10px;

    background-color: rgba(255, 255, 255, 0.6);

    cursor: pointer;
    transition: 0.2s;
}

.indicadores-fotos button.ativo {
    background-color: #fff;
}

.textos-servicos{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.titulo-servico{
    font-size: 16px;
    font-weight: 450;
    color: #3e3e3e;
}

.descricao-servico{
    font-size: 14px;
    color: #3e3e3e91;
}

.dados-ui-fundo{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    padding: 0 6px 0 0;
    margin-top: 8px;
}

.dados-ui {
    font-size: 15px;
    color: #3e3e3e;
    display: flex;
    align-items: center;
    gap: 1px;
}

.estrela {
    font-size: 18px;
    color: transparent !important;

    background: linear-gradient(
        90deg,
        #f5b301 var(--preenchimento),
        #d9d9d9 var(--preenchimento)
    );

    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.nota {
    margin-left: 6px;
    color: #555;
    font-size: 13px;
}

.dados-ui-texto{
    font-size: 12px;
    font-weight: 400;
    color: #3e3e3e;
    text-decoration: underline;
}

.contratar-servico{
    width: 100%;
    padding: 16px 32px;
    border-radius: 100px;
    margin-top: auto;
    background: none;
    border: solid 1.5px #25D366;
    color: #25D366;
    font-size: 14px;
    font-weight: 450;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all ease 0.4s;
}

.contratar-servico:hover{
    background-color: #25D366;
    color: #fff;
}

.contratar-servico:hover .icon-botao-wp{
    filter: brightness(0) invert(1);
}

.icon-botao-wp{
    position: absolute;
    left: 16px;
    width: 22px;
    height: 22px;
}

@media (min-width: 768px) and (max-width: 1200px){
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .conteudo-sessao-landing-page{
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px){
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .conteudo-sessao-landing-page{
        grid-template-columns: 1fr;
    }

    .titulo-padrao{
        font-size: 22px;
    }
}
</style>